import { PolIcon } from "components/PolIcon/policon";
import React from 'react';
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";
import { PROSPECT_ITEM, PROSPECT_ITEM_FORM } from "v4/data/apiRoutes";
import { usePolTranslation } from "v4/hooks/usePolTranslation";
import FormEntityLayout from "v4/layouts/FormEntityLayout/FormEntityLayout";
import ShowEntityLayout from "v4/layouts/ShowEntityLayout/ShowEntityLayout";
import 'v4/pages/front/Prospect/components/ProspectView/ProspectView.scss';
import ProspectViewActions
    from "v4/pages/front/Prospect/components/ProspectView/components/ProspectViewActions/ProspectViewActions";
import ProspectViewSubscriptions
    from "v4/pages/front/Prospect/components/ProspectView/components/ProspectViewSubscriptions/ProspectViewSubscriptions";
import useProspectView from "v4/pages/front/Prospect/components/ProspectView/hooks/useProspectView";

export default function ProspectView({ isExpanded, toggleExpanded }) {
    const { t } = usePolTranslation();
    const {
        isEditMode,
        toggleEditMode,
        prospectHeaderInfos,
        prospectId,
        onGetData,
        whenSubmitted,
        fetchFormParameters
    } = useProspectView({ isExpanded, toggleExpanded });

    return (
        <div className="prospect__view">
            <div className="prospect__view__header">
                <div className="prospect__view__header__title">
                    {prospectHeaderInfos
                        ? (
                            <>
                                <PolIcon icon={prospectHeaderInfos?.isBusiness ? 'company' : 'client'}/>
                                <span>{prospectHeaderInfos.fullname}</span>
                            </>
                        ) : (
                            <InlineLoader className="is-white"/>
                        )
                    }
                </div>
                <span className="prospect__view__header__close" onClick={toggleExpanded}>
                <PolIcon icon="close"/>
            </span>
            </div>
            {!isEditMode && (
                <div className="prospect__view__actions">
                    <ProspectViewActions isEditMode={isEditMode}
                                         toggleEditMode={toggleEditMode}
                                         hasGeoloc={prospectHeaderInfos?.lat}
                                         isUnknown={prospectHeaderInfos?.isUnknown}
                                         prospectId={prospectId}
                    />
                    <div className="prospect__view__actions__expand" onClick={toggleExpanded}>
                        {isExpanded
                            ? (
                                <>
                                    <PolIcon icon="arrow-left"/>
                                    <span>{t('show_less')}</span>
                                </>
                            ) : (
                                <>
                                    <span>{t('show_more')}</span>
                                    <PolIcon icon="arrow-right"/>
                                </>
                            )
                        }
                    </div>
                </div>
            )}
            <div className={`prospect__render ${isEditMode ? 'editing' : ''}`}>
                {isEditMode
                    ? (
                        <FormEntityLayout formRouteName={PROSPECT_ITEM_FORM}
                                          submitRouteName={PROSPECT_ITEM}
                                          fetchFormParameters={fetchFormParameters}
                                          onGetData={onGetData}
                                          onBack={toggleEditMode}
                                          whenSubmitted={whenSubmitted}
                        />
                    ) : (
                        <ShowEntityLayout entityRouteName={PROSPECT_ITEM_FORM}
                                          onGetData={onGetData}
                                          entityId={prospectId}
                        />
                    )
                }
                {
                    prospectHeaderInfos?.prospectSubscription?.length > 0
                    && !isEditMode
                    && (
                        <ProspectViewSubscriptions prospectSubscriptions={prospectHeaderInfos.prospectSubscription}
                                                   isExpanded={isExpanded}
                        />
                    )
                }
            </div>
        </div>
    )
}
